import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  font: {
    default: `'Fira Sans', sans-serif`,
    condensed: `'Fira Sans Condensed', sans-serif`,
    extra_condensed: `'Fira Sans Extra Condensed', sans-serif`,
  },
  colors: {
    // Colors
    primary: {
      color: '#104190',
      contrast: '#FFFFFF',
    },

    gray_blue: {
      color: '#455E70',
      contrast: '#FFFFFF',
    },

    gray_blue02: {
      color: '#7593AB',
      contrast: '#FFFFFF',
    },

    blue_label: {
      color: '#E4F1F8',
      contrast: '#FFFFFF',
    },

    blue01: {
      color: '#0F64A5',
      contrast: '#FFFFFF',
    },

    blue02: {
      color: '#4494D1',
      contrast: '#FFFFFF',
    },

    blue03: {
      color: '#42A09A',
      contrast: '#FFFFFF',
    },

    darkBlue: {
      color: '#00003A',
      contrast: '#FFFFFF',
    },

    yellow: {
      color: '#FFD503',
      contrast: '#FFFFFF',
    },
    orange: {
      color: '#E37F29',
      contrast: '#FFFFFF',
    },
    purple: {
      color: '#6458A5',
      contrast: '#FFFFFF',
    },

    // Texts
    title: '#34383A',
    texts: '#515151',
    texts_light: '#8D8D8D',

    border: '#E8E8E8',

    white: '#FFFFFF',
    black: '#000000',

    // Alerts
    confirmation: {
      color: '#3AC078',
      contrast: '#75C795',
    },
    danger: {
      color: '#FF5E48',
      contrast: '#FFFFFF',
    },
    information: {
      color: '#007bff',
      contrast: '#FFFFFF',
    },
    warning: {
      color: '#FB9C1C',
      contrast: '#FFFFFF',
    },

    // Backgrounds
    message: {
      color: '#7c7c8326',
      contrast: '#5B5C65',
    },
    light: {
      color: '#F3F3F3',
      contrast: '#F2F2F2',
    },
    medium: {
      color: '#606B6B',
      contrast: '#F5F5F5',
    },
    dark: {
      color: '#34383A',
      contrast: '#B2B2B2',
    },
  },
};

export default theme;
